export default __webpack_public_path__ + "static/media/twitter.843726e4.svg";